import { call, put } from 'redux-saga/effects';
import {
  downloadPatientFilesRequest,
  downloadPatientFilesSuccess,
  downloadPatientFilesFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* downloadPatientFilesByPatient(action) {
  yield put(downloadPatientFilesRequest());

  const patientId = action.payload.param.patientId;
  const filename = action.payload.param.filename;

  try {
    const result = yield call(
      Api.download,
      `${urls.aspariaBackend}api/v1/patient/fileDownload/${patientId}`,
      filename
    );
    if (result) {
      action.callback(result);
      yield put(downloadPatientFilesSuccess());
    } else {
      yield put(downloadPatientFilesFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(downloadPatientFilesFailure(e));
  }
}

export const downloadPatientFilesSagaAction = (param, cb) => ({
  type: SagaTypes.DOWNLOAD_PATIENT_FILES,
  payload: { param },
  callback: cb,
});
